// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

export const stickyElementZIndex = 1

export const modalZIndex = 40

export const errorModalZIndex = modalZIndex * 2

export const spinnerOverlayZIndex = modalZIndex / 2
